window.axios = require('axios');
import hljs from 'highlight.js/lib/core';
import Splide, { CLASS_PAGINATION } from '@splidejs/splide';
import '@splidejs/splide/css';

// Syntax highlighting
hljs.registerLanguage('bash', require('highlight.js/lib/languages/bash'));
hljs.registerLanguage('css', require('highlight.js/lib/languages/css'));
hljs.registerLanguage('html', require('highlight.js/lib/languages/xml'));
hljs.registerLanguage('javascript', require('highlight.js/lib/languages/javascript'));
hljs.registerLanguage('json', require('highlight.js/lib/languages/json'));
hljs.registerLanguage('markdown', require('highlight.js/lib/languages/markdown'));
hljs.registerLanguage('php', require('highlight.js/lib/languages/php'));
hljs.registerLanguage('scss', require('highlight.js/lib/languages/scss'));
hljs.registerLanguage('yaml', require('highlight.js/lib/languages/yaml'));

document.querySelectorAll('pre code').forEach((block) => {
    hljs.highlightBlock(block);
});

if (document.querySelector('.splide')) {
    new Splide( '.splide', {
        perPage: 3,
        type: 'loop',
        autoplay: true,
        gap: "1rem",
        breakpoints: {
            1023: {
              perPage: 2,
            },
            767: {
                perPage: 1
            }
      }
    }).mount();
}

const languagePickers = document.querySelectorAll('.js-language-selector');
const languageDropdowns = document.querySelectorAll('.js-language-options');

if (languagePickers && languageDropdowns) {
    const handleLanguagePopup = () => {

        Array.from(languageDropdowns).map(dropdown => {
            const isOpen = dropdown.classList.contains('block');
    
            if (isOpen) {
                dropdown.classList.add('hidden');
                dropdown.classList.remove('block');
            } else {
                dropdown.classList.remove('hidden');
                dropdown.classList.add('block');
            }
        })
    };

    Array.from(languagePickers).map(languagePicker => 
        languagePicker.addEventListener('click', handleLanguagePopup)
    );    
}


// Get all the elements you want to track
const vitalsWrapper = document.querySelector('[data-vitals]');
const vitals = document.querySelectorAll('[data-vital]');

if (vitals && vitalsWrapper) {
    // on window scroll
    window.addEventListener('scroll', (e) => {
        const activeClass = 'c-vital--active';
        const heightFromTop = window.getComputedStyle(vitalsWrapper).getPropertyValue('--vitals-height-from-top');

        console.log(heightFromTop);

        vitals.forEach( section => {
            const topDistance = section.getBoundingClientRect().top;

            if (topDistance > 0 && topDistance < heightFromTop) {
                section.classList.add(activeClass);
            } else {
                section.classList.remove(activeClass);
            }
        });
    });
}

